import React from "react";
import styles from "./vertical-separator.module.scss";

export type VerticalSeparatorProps = React.HTMLAttributes<HTMLDivElement>;

const className = "vertical-separator";

export const VerticalSeparator = ({ ...rest }: VerticalSeparatorProps) => {
  return (
    <div
      className={styles[className]}
      role="presentation"
      aria-hidden="true"
      {...rest}
    />
  );
};
